import React from 'react';

const EmptyCart = ({ cartConfig }) => {
  return (
    <div className="mt-12 text-center">
      <h3 className="text-2xl font-bold text-blue-950">
        {cartConfig.empty_title}
      </h3>
      <p className="mt-1.5 text-base font-book text-blue-950">
        {cartConfig.empty_secondary_text}
      </p>
      <div className="mt-8">
        <a
          className="inline-flex min-w-40 items-center justify-center rounded bg-blue-500 hover:bg-blue-950 lg:h-12 px-12 py-3 text-base font-medium text-white"
          href={cartConfig.empty_cta_link}
        >
          {cartConfig.empty_cta_title}
        </a>
      </div>
    </div>
  );
};

export default EmptyCart;
